"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardLink = exports.Link = exports.StyledCol = exports.SubText = exports.StyledGrid = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactStyledFlexboxgrid = require("react-styled-flexboxgrid");
var _typography = require("@berlitz/globals/lib/components/typography");
var _layout = require("@berlitz/globals/lib/components/layout");
var _link = require("@berlitz/link");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var StyledGrid = (0, _styledComponents.default)(_layout.Grid).withConfig({
  displayName: "style__StyledGrid",
  componentId: "sc-12f7yx3-0"
})(["@media (min-width:", "){margin-bottom:-", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.lg;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.space.md;
});
exports.StyledGrid = StyledGrid;
var SubText = (0, _styledComponents.default)(_typography.P).withConfig({
  displayName: "style__SubText",
  componentId: "sc-12f7yx3-1"
})(["margin:0 auto;max-width:", ";"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoints.md;
});
exports.SubText = SubText;
var StyledCol = (0, _styledComponents.default)(_reactStyledFlexboxgrid.Col).withConfig({
  displayName: "style__StyledCol",
  componentId: "sc-12f7yx3-2"
})(["margin:0 auto;margin-bottom:", ";&:last-child{margin-bottom:0;}@media (min-width:", "){margin:0;}@media (min-width:", "){padding:", ";}"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.space.lg;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.breakpoints.sm;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.breakpoints.lg;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.space.md;
});
exports.StyledCol = StyledCol;
var Link = _styledComponents.default.a.withConfig({
  displayName: "style__Link",
  componentId: "sc-12f7yx3-3"
})(["", ""], _link.linkStyle);
exports.Link = Link;
var CardLink = _styledComponents.default.a.withConfig({
  displayName: "style__CardLink",
  componentId: "sc-12f7yx3-4"
})(["text-decoration:none;"]);
exports.CardLink = CardLink;